/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `enabled` - Enabled
 * * `disabled` - Disabled
 * * `none` - None
 * @export
 */
export const TwoFaStatusEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    None: 'none'
} as const;
export type TwoFaStatusEnum = typeof TwoFaStatusEnum[keyof typeof TwoFaStatusEnum];


export function instanceOfTwoFaStatusEnum(value: any): boolean {
    for (const key in TwoFaStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(TwoFaStatusEnum, key)) {
            if (TwoFaStatusEnum[key as keyof typeof TwoFaStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TwoFaStatusEnumFromJSON(json: any): TwoFaStatusEnum {
    return TwoFaStatusEnumFromJSONTyped(json, false);
}

export function TwoFaStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TwoFaStatusEnum {
    return json as TwoFaStatusEnum;
}

export function TwoFaStatusEnumToJSON(value?: TwoFaStatusEnum | null): any {
    return value as any;
}

export function TwoFaStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TwoFaStatusEnum {
    return value as TwoFaStatusEnum;
}

